import { Box, styled } from '@mui/material'
import { LinkContrastText } from '../../styles/Typography.styled'
import { mobile } from '../../../utils/breakpoints'

export const LeftContentWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  ${({ theme }) => mobile(theme, { 'align-items': 'center' })}
`

export const LinkContainer = styled(Box)`
  display: flex;
  justify-content: flex-start;
  text-align: left;
  align-items: flex-start;
  ${({ theme }) => mobile(theme, { 'flex-direction': 'column', 'align-items': 'center' })}
`

export const LogoImage = styled('img')`
  max-height: 50px;
  margin-bottom: 20px;

  ${({ theme }) => mobile(theme, { maxHeight: '30px' })}
`

export const TextLink = styled(LinkContrastText)`
  padding: 0 10px;
  text-wrap-mode: nowrap;
`
